import axios from "axios";

export default class ObjectReportService {

    private static instance: ObjectReportService;
    private localIsOpen: boolean = false;

    private constructor() {
    }

    public static getInstance(): ObjectReportService {
        if (!ObjectReportService.instance) {
            ObjectReportService.instance = new ObjectReportService();
        }
        return ObjectReportService.instance;
    }

    public openForm(): void {
        this.localIsOpen = true;
    }

    public closeForm(): void {
        this.localIsOpen = false;
    }

    public isOpen(): boolean {
        return this.localIsOpen;
    }

    public sendEmail(formData: FormData): Promise<string> {
        const url: string = '/index.php?option=com_mammadaba_map&view=email&format=json';
        return axios.post(url, formData, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        });
    }
}